export default "__VITE_ASSET__BwtVFhQj__"